import { useMemo } from "react";
import { Box } from "@mui/material";

import { useAsu } from "@framework/provider-asu";

import { SELECTED_ITEM_TYPE, getSelectedItemType } from "../../../../utils";

import { StationEventsTable } from "./table";
import { TrainEvents } from "../scheme/components/events";

export const EventsLog = () => {
  const { selectedItem } = useAsu();
  const selectedItemType = useMemo(() => getSelectedItemType(selectedItem), [selectedItem]);
  return (
    <Box sx={{ height: "calc(100vh - 208px)", minHeight: 520 }}>
      {selectedItemType === SELECTED_ITEM_TYPE.station ? <StationEventsTable /> : <TrainEvents />}
    </Box>
  );
};
